import React, {Component} from 'react';
import './AuthScreen.css';
import AuthLogo from "./AuthLogo";
import PropTypes from 'prop-types';

export default class AuthScreen extends Component {
    componentDidMount() {

    }

    render() {
        return <div className={"AuthScreen"}>
            <div className={"AuthScreen__logowrap"}>
                <AuthLogo/>
            </div>

            <div className={"AuthScreen__inner"}>
                {this.props.title && <h1 className={"AuthScreen__inner-title"}>{this.props.title}</h1>}
                {this.props.children}
            </div>
        </div>
    }
}

AuthScreen.propTypes = {
    title: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Auth/AuthScreen.js